import React,{useEffect,useState} from 'react';
import {useNavigate } from 'react-router-dom';
import {reactLocalStorage} from 'reactjs-localstorage';

import {API_URL} from '../../components/constant.js'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";



function Login(){

  /******************************** */
  const navigat =useNavigate();
  const isLogin=reactLocalStorage.get('isLogin');
  useEffect(() => {
      if(isLogin){
      return  navigat('/dashboard')
      
       }
       document.title='Login';
    });

  
   /********************disable enable************************* */

   const [disDiv, setDisDiv] = useState(false);


/********************google recapcha enable************************* */
   
const [captchaToken, setCaptchaToken] = useState(null);
const [captchaError, setCaptchaError] = useState(false);

const onCaptchaChange = (token) => {
  setCaptchaToken(token);
  setCaptchaError(false);
};

 /*************Submit******************** */
  
  let doLogin = async(e)=>{
    setDisDiv(true);
    e.preventDefault();
     if (!captchaToken) {
    setCaptchaError(true);
     setDisDiv(false);
    return;
  }
    if(validate(e)){
      const data = new FormData(e.target);
      let formData = {
        'email':data.get('email'),
        'password':btoa(data.get('password')) ,
        'token':captchaToken

      };
   
     
    const regData = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
     }
     const getResp = await fetch(API_URL+'admin/login',regData);
     const getdatas = await getResp.json();   
     
      if(getdatas.status=='200'){
        reactLocalStorage.set('isLogin',true);
        reactLocalStorage.set('user_name',getdatas.res_data.name);
        reactLocalStorage.set('user_email',getdatas.res_data.email);
        reactLocalStorage.set('userLoginType',"Admin");

        reactLocalStorage.set('chc_phc',"");
        reactLocalStorage.set('block',"");
        reactLocalStorage.set('district',"");
        
      setDisDiv(false);
          return navigat('/dashboard');
      }else{
       
       // notify("Wrong Username/Password");
       notify("Invalid Credentials");
        setDisDiv(false);
      }

       
    }

}
/**************Validation************************* */
let validate = (ev) => {
  const data = new FormData(ev.target);
  let validat = true;
   if(data.get('email') == ''){
    notify('Please enter email');
     validat = false;
   }else{
    let emailRegExp="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";
     //let testemail= emailRegExp.test(data.get('email'));
     let testemail= data.get('email').match(emailRegExp);
     if(testemail){
      return validat = true;
     }else{ notify('Wrong email');
     return validat = false;
     }
   }
  }
 /*********************Toast****************************** */
 const notify = (e) => toast(e);
 /******************************************************* */
 
    return (
<>
<ToastContainer />
<div className="container-scroller">
    <div className="container-fluid page-body-wrapper full-page-wrapper">
      <div className="content-wrapper d-flex align-items-center auth px-0">
        <div className="row w-100 mx-0">
          <div className="col-lg-4 mx-auto">
            <div className="auth-form-light text-left py-5 px-4 px-sm-5">
              <div className="brand-logo" style={{"textAlign":"center"}}>
                <img src={process.env.PUBLIC_URL+"/images/logo.png"} alt="logo" style={{"width":"65px"}} />
              </div>
              <h4>T4 Admin Login</h4>
              <h6 className="font-weight-light">Sign in to continue.</h6>
              <form className="pt-3" onSubmit={doLogin}>
                <div className="form-group">
                  <input 
                   type="email" 
                   name="email" 
                   className="form-control form-control-lg"
                   id="exampleInputEmail1"
                   placeholder="Email"  
                   autoComplete="off"
                   required
                   onCopy={(e) => e.preventDefault()}
                   onPaste={(e) => e.preventDefault()}
                   onCut={(e) => e.preventDefault()}
                   />
                  
                </div>
                <div className="form-group">
                  {/* <input type="password" name="password" className="form-control form-control-lg" id="exampleInputPassword1" placeholder="Password" required/> */}
                   <input
                    type="password"
                    className="form-control form-control-lg"
                    id="exampleInputPassword1"
                    name="password"
                    placeholder="Password"
                    autoComplete="off"
                    required
                    onCopy={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                    onCut={(e) => e.preventDefault()}
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                    title="Must contain at least 8 characters, including 1 uppercase, 1 lowercase, 1 number, and 1 special character"
                    />
                </div>

                  {/* 🔐 GOOGLE CAPTCHA */}
              <div className="form-group">
                <ReCAPTCHA
                  // sitekey="6Le9KUosAAAAANsHgIdvntiktiK8e1fsmgyMqkcP"
                   sitekey="6LeCwforAAAAANZkuTWimqVM_M2NkEO124-ZjiNE"
                  onChange={onCaptchaChange}
                />
                {captchaError && (
                  <small className="text-danger">
                    Please verify captcha
                  </small>
                )}
              </div>

                <div className="mt-3">
                  <button type="submit" id="btn" className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" disabled={disDiv}  >SIGN IN</button>
                </div>
                <div className="my-2 d-flex justify-content-between align-items-center"> 
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </>
    );
}

export default Login ;